import Sidebar from '../../components/Sidebar/Sidebar'
import DashboardStatCard from '../../components/DashboardStatCard/DashboardStatCard'

import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip
} from 'recharts'

import {
  ChartLine,
  ClockCounterClockwise
} from '@phosphor-icons/react'

import './Dashboard.scss'

const topSellingItems = [
  {
    id: 1,
    name: 'Miso Ramen Noodle',
    category: 'Noodles',
    price: 'RM18.90',
    revenue: 'RM6,830.20',
    sold: '68 sold',
    image:
      'https://images.unsplash.com/photo-1617093727343-374698b1b08d?q=80&w=400&auto=format&fit=crop'
  },
  {
    id: 2,
    name: 'Chicken Katsu Don',
    category: 'Rice',
    price: 'RM22.90',
    revenue: 'RM4,282.70',
    sold: '53 sold',
    image:
      'https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?q=80&w=400&auto=format&fit=crop'
  },
  {
    id: 3,
    name: 'Beef Teppanyaki Set',
    category: 'Noodles',
    price: 'RM29.90',
    revenue: 'RM3,912.20',
    sold: '80 sold',
    image:
      'https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=400&auto=format&fit=crop'
  },
  {
    id: 4,
    name: 'Salmon Don',
    category: 'Rice',
    price: 'RM28.90',
    revenue: 'RM2,772.60',
    sold: '280 sold',
    image:
      'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?q=80&w=400&auto=format&fit=crop'
  },
  {
    id: 5,
    name: 'Chicken Katsu Curry',
    category: 'Rice',
    price: 'RM28.90',
    revenue: 'RM2,268.60',
    sold: '236 sold',
    image:
      'https://images.unsplash.com/photo-1604909052743-94e838986d24?q=80&w=400&auto=format&fit=crop'
  }
]

const recentOrders = [
  {
    id: '#ORD-2025-04821',
    items:
      'Salmon Teriyaki Bento x 1, Beef Teppanyaki Plate x 1, Yuzu Lemonade x 1, Cola x 1',
    customer: 'Bernard Liew',
    total: 'RM97.60'
  },
  {
    id: '#ORD-2025-04820',
    items:
      'Chicken Karaage Plate x 1, Miso Soup with Rice x 1, Yuzu Lemonade x 1',
    customer: 'Guest#14524152',
    total: 'RM80.60'
  },
  {
    id: '#ORD-2025-04819',
    items:
      'Chicken Katsu Don x 1, Yuzu Lemonade x 1, Uni Temaki x 1',
    customer: 'Bong Ming Lee',
    total: 'RM66.40'
  },
  {
    id: '#ORD-2025-04818',
    items:
      'Beef Teppanyaki Plate x 1, Yuzu Lemonade x 1, Cola x 1',
    customer: 'Guest#14575012',
    total: 'RM58.20'
  }
]

const revenueData = [
  { date: '30 Apr', revenue: 27000 },
  { date: '1 May', revenue: 27000 },
  { date: '2 May', revenue: 25000 },
  { date: '3 May', revenue: 31500 },
  { date: '4 May', revenue: 26800 },
  { date: '5 May', revenue: 25500 },
  { date: '6 May', revenue: 31200 }
]

export default function Dashboard() {
  return (
    <div className="dashboard-layout">
      <main className="dashboard-page">
        <div className="dashboard-header">
          <div>
            <div className="dashboard-breadcrumb">
              Hikari House / Dashboard
            </div>

            <h1>
              Good morning, Xavier Liew
            </h1>

            <p className="dashboard-subtitle">
              Tuesday, 6 May 2025 • Hikari House
            </p>
          </div>

          <div className="dashboard-range-tabs">
            <button className="active">
              Today
            </button>

            <button>Week</button>

            <button>Month</button>
          </div>
        </div>

        <div className="dashboard-stats">
          <DashboardStatCard
            title="Revenue"
            value="RM4,250.80"
            growth="↑ 18.2%"
          />

          <DashboardStatCard
            title="Orders"
            value="RM4,820.00"
            growth="↑ 16.8%"
          />

          <DashboardStatCard
            title="AVG Order Value"
            value="RM87.60"
            growth="↓ 1.8%"
            negative
          />

          <DashboardStatCard
            title="Discounts Given"
            value="RM142.00"
            subtitle="8 vouchers • 4 promo codes"
          />
        </div>

        <div className="dashboard-grid">
          <div className="dashboard-card dashboard-chart-card">
            <div className="dashboard-card__header">
              <h3>Daily revenue</h3>
            </div>

            <div className="dashboard-chart" tabIndex={-1}>
              <ResponsiveContainer
                width="100%"
                height={360}
              >
                <AreaChart data={revenueData}>
                  <CartesianGrid
                    strokeDasharray="3 3"
                    stroke="#e4e4e7"
                  />

                  <XAxis
                    dataKey="date"
                    tick={{
                      fontSize: 14,
                      fill: '#71717a'
                    }}
                    axisLine={false}
                    tickLine={false}
                  />

                  <YAxis
                    tick={{
                      fontSize: 14,
                      fill: '#71717a'
                    }}
                    axisLine={false}
                    tickLine={false}
                  />

                  <Tooltip />

                  <Area
                    type="monotone"
                    dataKey="revenue"
                    stroke="#22c7ee"
                    fill="#22c7ee"
                    fillOpacity={0.18}
                    strokeWidth={3}
                  />
                </AreaChart>
              </ResponsiveContainer>

              <div className="dashboard-chart__legend">
                <div className="dashboard-chart__legend-line" />

                Revenue
              </div>
            </div>
          </div>

          <div className="dashboard-card dashboard-top-selling">
            <div className="dashboard-card__header">
              <h3>Top-selling items</h3>
            </div>

            <div className="dashboard-top-selling__list">
              {topSellingItems.map(
                (item, index) => (
                  <div
                    key={item.id}
                    className="dashboard-top-selling__item"
                  >
                    <div className="dashboard-top-selling__left">
                      <div className="dashboard-top-selling__rank">
                        {index + 1}
                      </div>

                      <img
                        src={item.image}
                        alt={item.name}
                      />

                      <div>
                        <h4>
                          {item.name}
                        </h4>

                        <p>
                          {
                            item.category
                          }{' '}
                          •{' '}
                          {
                            item.price
                          }
                        </p>
                      </div>
                    </div>

                    <div className="dashboard-top-selling__right">
                      <h5>
                        {
                          item.revenue
                        }
                      </h5>

                      <p>
                        {
                          item.sold
                        }
                      </p>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>

        <div className="dashboard-card dashboard-recent-orders">
          <div className="dashboard-card__header">
            <h3>Recent orders</h3>
          </div>

          <div className="dashboard-recent-orders__list">
            {recentOrders.map((order) => (
              <div
                key={order.id}
                className="dashboard-recent-orders__item"
              >
                <div className="dashboard-recent-orders__id">
                  {order.id}
                </div>

                <div className="dashboard-recent-orders__content">
                  <p className="dashboard-recent-orders__items">
                    {order.items}
                  </p>

                  <div className="dashboard-recent-orders__meta">
                    <span>
                      {
                        order.customer
                      }
                    </span>

                    •
                    <span>
                      {
                        order.total
                      }
                    </span>
                  </div>
                </div>

                <div className="dashboard-recent-orders__status">
                  <span>
                    • Open
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  )
}